import React, { FC } from "react";
import { Link } from "react-router-dom";

type PropsType = {
  tabs: {
    id: number;
    name: string;
    isActive: boolean;
    href: string;
  }[];
  className?: string;
};

export const TabBlocks: FC<PropsType> = ({ tabs, className }: PropsType) => {
  return (
    <div className={`flex space-x-4 ${className}`}>
      {tabs.map((tab, index) => (
        <Link
          key={index}
          to={tab.href}
          className={`
          px-4 py-2 rounded-t-lg border-t border-l border-r border-secondary-300
          ${tab.isActive ? "text-white bg-primary-600" : "bg-white text-secondary-900"}
        `}
        >
          {tab.name}
        </Link>
      ))}
    </div>
  );
};
